export default __webpack_public_path__ + "static/media/herobg.845038f0.jpeg";